import { type GetImpulseFormInput, ImpulseFormOptional, ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";
import type { Partial } from "~/tools/partial";
import { trim } from "~/tools/trim";

import { WidgetDecimals } from "../decimals/form-state";
import { WidgetUnit } from "../unit/form-state";

type WidgetYAxisShow = ImpulseFormUnit<boolean>;

type WidgetYAxisLabel = ImpulseFormUnit<string, null, undefined | string>;

type WidgetYAxis = ImpulseFormOptional<
	ImpulseFormUnit<boolean>,
	ImpulseFormShape<{
		unit: WidgetUnit;
		decimals: WidgetDecimals;
		label: WidgetYAxisLabel;
	}>
>;

const DEFAULT = {
	enabled: true,
	element: {
		unit: WidgetUnit.default,
		decimals: WidgetDecimals.default,
		label: "",
	},
} satisfies GetImpulseFormInput<WidgetYAxis>;

function init(initial?: Partial<GetImpulseFormInput<WidgetYAxis>, "deep">): WidgetYAxis {
	return ImpulseFormOptional(
		ImpulseFormUnit(initial?.enabled ?? DEFAULT.enabled),
		ImpulseFormShape({
			unit: WidgetUnit.init(initial?.element?.unit ?? DEFAULT.element.unit),

			decimals: WidgetDecimals.init(initial?.element?.decimals ?? DEFAULT.element.decimals),

			label: ImpulseFormUnit(initial?.element?.label ?? DEFAULT.element.label, {
				isInputDirty: isStringDirty,
				transform: trim,
			}),
		}),
	);
}

const WidgetYAxis = {
	default: DEFAULT,
	init,
} as const;

export { WidgetYAxis };
export type { WidgetYAxisShow, WidgetYAxisLabel };
